import { render, staticRenderFns } from "./rwstep2.vue?vue&type=template&id=037c9a88&scoped=true&"
import script from "./rwstep2.vue?vue&type=script&lang=js&"
export * from "./rwstep2.vue?vue&type=script&lang=js&"
import style0 from "./rwstep2.vue?vue&type=style&index=0&id=037c9a88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c9a88",
  null
  
)

export default component.exports